import React, { useState } from "react";
import { Send, Heart, Sparkles, Flame, Ghost, Instagram } from "lucide-react";
import { api } from "../lib/api";

const MOODS = [
  { key: "tabou", label: "Tabou", icon: Ghost },
  { key: "chaud", label: "Chaud", icon: Flame },
  { key: "amour", label: "Amour", icon: Heart },
  { key: "weird", label: "Weird", icon: Sparkles },
];

export default function ConfessionBox({ settings }) {
  const [text, setText] = useState("");
  const [mood, setMood] = useState(null);
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (text.trim().length < 5) {
      setErr("Au moins 5 caractères, balance.");
      return;
    }
    setLoading(true);
    try {
      await api.post("/confessions", { text, mood });
      setSent(true);
      setText("");
      setMood(null);
    } catch (e2) {
      const d = e2.response?.data?.detail;
      setErr(typeof d === "string" ? d : "Petit souci, réessaie dans un instant.");
    } finally {
      setLoading(false);
    }
  };

  const insta = settings?.instagram_handle || "@bonsangmagazine";

  return (
    <section
      data-testid="confession-section"
      className="border-y-2 border-black"
      style={{ background: "#0A8074" }}
    >
      <div className="mx-auto max-w-[1200px] px-5 lg:px-10 py-20 lg:py-28 grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-5 text-[#FFFDF7]">
          <span className="pill-tag bg-[#FFD01E] mb-5">Anonyme · 100%</span>
          <h2 className="font-display-black text-5xl sm:text-7xl leading-[0.9]">
            {settings?.confession_title_1 || "Confession"}
            <br />
            <span className="text-[#FFD01E]">{settings?.confession_title_2 || "intime."}</span>
          </h2>
          <p className="mt-5 text-base lg:text-lg max-w-md">
            {settings?.confession_intro ||
              "Balance ta confession. Anonyme, sans filtre. On en sélectionne pour les partager sur Instagram."}
          </p>
          <a
            href={`https://instagram.com/${insta.replace("@", "")}`}
            target="_blank"
            rel="noreferrer"
            data-testid="confession-insta-link"
            className="brutal-btn brutal-btn-yellow mt-6"
          >
            <Instagram size={16} /> Voir les confessions sur {insta}
          </a>
        </div>

        <div className="lg:col-span-7">
          {sent ? (
            <div
              data-testid="confession-thanks"
              className="brutal-card p-8 bg-[#FFD01E] flex flex-col items-start gap-4"
            >
              <h3 className="font-display-black text-4xl">Reçue 🍒</h3>
              <p>Merci pour ta confession. Garde un œil sur l&apos;Insta — peut-être qu&apos;on la fera vivre.</p>
              <button
                data-testid="confession-new"
                onClick={() => setSent(false)}
                className="brutal-btn brutal-btn-coral"
              >
                Envoyer une autre
              </button>
            </div>
          ) : (
            <form
              onSubmit={submit}
              data-testid="confession-form"
              className="brutal-card p-6 lg:p-8 flex flex-col gap-4"
              style={{ background: "#FFFDF7" }}
            >
              <label className="block">
                <span className="text-xs uppercase font-bold tracking-widest">
                  Ta confession ({text.length}/2000)
                </span>
                <textarea
                  data-testid="confession-textarea"
                  value={text}
                  onChange={(e) => setText(e.target.value.slice(0, 2000))}
                  placeholder="Hier soir, j'ai…"
                  className="mt-2 w-full min-h-[180px] border-2 border-black rounded-xl p-4 text-base bg-white focus:outline-none focus:bg-[#FFD01E]/20 transition-colors"
                  required
                />
              </label>
              <div className="flex flex-wrap items-center gap-2">
                <span className="text-xs uppercase font-bold tracking-widest mr-1">Mood :</span>
                {MOODS.map((m) => {
                  const active = mood === m.key;
                  const Icon = m.icon;
                  return (
                    <button
                      type="button"
                      key={m.key}
                      data-testid={`mood-${m.key}`}
                      onClick={() => setMood(active ? null : m.key)}
                      className={`pill-tag transition-colors ${active ? "bg-[#FA6157] text-white" : ""}`}
                    >
                      <Icon size={12} className="mr-1" /> {m.label}
                    </button>
                  );
                })}
              </div>
              {err && <p data-testid="confession-error" className="text-sm text-[#FA6157] font-bold">{err}</p>}
              <button
                data-testid="confession-submit"
                type="submit"
                disabled={loading}
                className="brutal-btn brutal-btn-coral self-start"
              >
                <Send size={16} /> {loading ? "Envoi…" : "Balance ta confession"}
              </button>
              <p className="text-xs text-black/50">
                Aucun nom, aucun email collecté. Ta confession arrive directement dans la boîte de la rédac.
              </p>
            </form>
          )}
        </div>
      </div>
    </section>
  );
}
